module.exports = __webpack_public_path__ + "static/mentecerta-ee5570f2426589c96d5340da038919c1.mp4";